import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
	animate,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';
import {
	MatSidenavContainer,
	MatSidenav,
	MatSidenavContent,
} from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
	selector: 'app-sanity-checks',
	templateUrl: './sanity-checks.component.html',
	styleUrls: ['./sanity-checks.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [
		trigger('sideNavMenuAnimationState', [
			state(
				'topX',
				style({
					transform: 'rotate(45deg)',
					transformOrigin: 'left',
					margin: '7px',
				})
			),
			state(
				'hide',
				style({
					opacity: 0,
				})
			),
			state(
				'bottomX',
				style({
					transform: 'rotate(-45deg)',
					transformOrigin: 'left',
					margin: '7px',
				})
			),
			state('line', style({})),
			transition(':enter', []),
			transition('* => *', [animate('0.2s')]),
		]),
	],
	imports: [
		MatSidenavContainer,
		MatSidenav,
		MatNavList,
		MatListItem,
		RouterLinkActive,
		RouterLink,
		MatIcon,
		MatSidenavContent,
		NgClass,
		RouterOutlet,
	],
})
export class SanityChecksComponent {
	isSideNavMenuOpen = false;
	constructor() {}

	ngOnInit(): void {}

	toggleSideNav() {
		this.isSideNavMenuOpen = !this.isSideNavMenuOpen;
	}
}
